import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

import logo from "./logo.png";
import MenuUser from "./MenuUser";
import { useAuth0 } from "@auth0/auth0-react";

import { useState } from "react";
import { MenuItemType, Props } from "./types";
import { responsiveAppBarStyles } from "./styles";
import { LoggedInAppBar } from "./LoggedInAppBar";
import { SVG_ICON_COLOR } from "../../theme";
import { ArtistsSvg, ExploreSvg, FilesSvg, HubSvg } from "../SVGIcons";

const userMenu: MenuItemType[] = [
  {
    value: <MenuUser user={""} imageUrl={""} subscriptionTier={0} />,
    id: 1,
    route: "",
  },
  { value: "Messages", id: 3, route: "Messages" },
  { value: "My NFTs", id: 5, route: "my-nfts" },
  { value: "Billing", id: 6, route: "billing" },
  { value: "Settings", id: 4, route: "Settings" },
  { value: "Log Out", id: 7, route: "" },
];

export const userPages = [
  {
    name: "Tracks",
    route: "/my-tracks",
    component: <HubSvg color={SVG_ICON_COLOR} />,
  },
  {
    name: "Files",
    route: "/my-files",
    component: <FilesSvg color={SVG_ICON_COLOR} />,
  },
  {
    name: "Explore",
    route: "/explore",
    component: <ExploreSvg color={SVG_ICON_COLOR} />,
  },
  {
    name: "Artists",
    route: "/explore-artists",
    component: <ArtistsSvg color={SVG_ICON_COLOR} />,
  },
];

const ResponsiveNavbar: React.FC<Props> = ({ currentUser }) => {
  const [anchorElNav, setAnchorElNav] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);
  const [anchorElUser, setAnchorElUser] = useState<
    (EventTarget & HTMLButtonElement) | null
  >(null);

  const { loginWithRedirect, isAuthenticated, logout, user } = useAuth0();

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (anchorElUser) {
      setAnchorElUser(null);
    }
    if (anchorElNav) {
      setAnchorElNav(null);
    } else {
      setAnchorElNav(event.currentTarget);
    }
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (anchorElNav) {
      setAnchorElNav(null);
    }
    if (anchorElUser) {
      setAnchorElUser(null);
    } else {
      setAnchorElUser(event.currentTarget);
    }
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = (item: MenuItemType) => {
    if (item.value === "Log Out") {
      logout({ returnTo: window.location.origin + "/logout" });
    }
    setAnchorElUser(null);
  };

  //when no user is logged in
  const notLoggedIn = () => {
    return (
      <AppBar sx={responsiveAppBarStyles.appBar} position="static">
        <Container maxWidth="xl">
          <Toolbar>
            <Box sx={responsiveAppBarStyles.toolbarImageContainer}>
              <Link to="/">
                <img className="logo-image" src={logo} alt="logo" />
              </Link>
            </Box>
            <Button
              sx={responsiveAppBarStyles.loginSignUpButton}
              size="small"
              variant="outlined"
              onClick={() =>
                loginWithRedirect({
                  appState: { targetUrl: "/" },
                })
              }
            >
              Log in | Sign up
            </Button>
          </Toolbar>
        </Container>
      </AppBar>
    );
  };

  //when user is logged in
  const LoggedIn = () => {
    return (
      <>
        <LoggedInAppBar
          currentUser={currentUser}
          userPages={userPages}
          handleOpenNavMenu={handleOpenNavMenu}
          anchorElNav={anchorElNav}
          handleCloseNavMenu={handleCloseNavMenu}
          handleOpenUserMenu={handleOpenUserMenu}
          anchorElUser={anchorElUser}
          user={user}
          userMenu={userMenu}
          handleCloseUserMenu={handleCloseUserMenu}
          setAnchorElUser={setAnchorElUser}
        />
      </>
    );
  };
  if (isAuthenticated) return LoggedIn();
  return notLoggedIn();
};
export default ResponsiveNavbar;
